import { ReactElement } from 'react';
import useConfig from '../../hooks/ui/useConfig';
import classNames from 'classnames';
import useStorefront from '../../hooks/storefront/useStorefront';

interface Props {
  className?: string;
}

export default function CompanyLogo({ className }: Props): ReactElement {
  const { logo_url } = useConfig();
  const { isStorefront } = useStorefront();

  if (isStorefront) {
    return (
      <img src={logo_url} alt="Logo" className={classNames('lg:h-[52px] h-[42px] flex object-contain', className)} />
    );
  }

  return logo_url ? (
    <img src={logo_url} alt="Logo" className={classNames('h-12 flex object-contain', className)} />
  ) : null;
}
